module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har tackat nej till jobbet":"has declined the job","Klicka":"Click","här":"here","för att se anledningen":"to see the reasons"},"sv":{"Kandidaten":"Kandidaten","har tackat nej till jobbet":"har tackat nej till jobbet","Klicka":"Klicka","här":"här","för att se anledningen":"för att se anledningen"}}')
  delete Component.options._Ctor
}
